export default __webpack_public_path__ + "static/media/cfe.84d74bc0.svg";